
<script>
import Icon from "@/components/atoms/icon";
import Button from "@/components/atoms/button";

export default {
  name: "StoreAttachment",
  components: {
    Icon,
    Button
  },
  props: {
    isNational: {
      type: Boolean,
      required: false,
      default: false
    },
    shopName: {
      type: String,
      required: false,
      default: ""
    },
    shopfirstSlotAvailable: {
      type: String,
      required: false,
      default: ""
    }
  },
  emits: ["displayOrCloseStoreLocatorPopin", "togglePlanningPopin"]
};
</script>
<template>
  <div>
    <div v-if="isNational">
      <Button
        class="c-store-attachment__button"
        @click="$emit('displayOrCloseStoreLocatorPopin')"
      >
        <div class="u-flex">
          <Icon
            name="shop"
            size="md"
            variant="primary"
            class="c-store-attachment__icon u-mr-sm"
          />
          <span class="u-color-black">
            <span class="u-font-500 u-font-17 u-mb-xs u-block">Sélectionnez votre magasin </span>
            pour consulter les prix et les disponibilités des produits
          </span>
        </div>
        <Icon
          name="arrow-right"
          class="c-store-attachment__icon"
          size="sm"
        />
      </Button>
    </div>
    <div v-else>
      <div class="u-flex">
        <Icon
          name="shipping-drv"
          size="xlg"
          variant="primary"
          class="u-mr-sm u-flex-shrink-none"
        />
        <div>
          <div class="u-mb-md">
            <h2 class="u-font-500 u-font-17 u-mb-xxs">
              Prochain créneau drive disponible
            </h2>
            <p
              v-if="shopfirstSlotAvailable"
              class="u-font-16 u-color-primary u-font-600 u-mb-xxs"
            > {{ shopfirstSlotAvailable }}</p>
            <p
              v-else
              class="u-font-16 u-color-primary u-font-600 u-mb-xxs"
            > Aucun créneau n'est disponible pour le moment </p>
            <Button link>
              <span
                class="u-font-16"
                @click="$emit('togglePlanningPopin')"
              >Voir le planning</span>
            </Button>
          </div>
          <div>
            <p class="u-font-17 u-font-500 u-mb-xxs">Cora {{ shopName }} </p>
            <Button link>
              <span
                class="u-font-16"
                @click="$emit('displayOrCloseStoreLocatorPopin')"
              >Changer de magasin</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/store-attachment.scss";
</style>
